import { useState, useEffect, useRef } from 'react';

function getInitialTheme() {
  try {
    const stored = localStorage.getItem('graph-paper-theme');
    if (stored === 'dark' || stored === 'light') return stored;
  } catch {}
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch {}
  return 'light';
}

export default function SiteNav({ onPrint, onDownload }) {
  const [theme, setTheme] = useState(getInitialTheme);
  const [mobileDownloadOpen, setMobileDownloadOpen] = useState(false);
  const mobileDownloadRef = useRef(null);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem('graph-paper-theme', theme); } catch {}
  }, [theme]);

  useEffect(() => {
    function handleClick(e) {
      if (mobileDownloadRef.current && !mobileDownloadRef.current.contains(e.target)) {
        setMobileDownloadOpen(false);
      }
    }
    if (mobileDownloadOpen) {
      document.addEventListener('mousedown', handleClick);
    }
    return () => document.removeEventListener('mousedown', handleClick);
  }, [mobileDownloadOpen]);

  return (
    <nav className="navbar">
      <a href="/" className="navbar-brand">
        <img src="/favicon.svg" alt="" className="navbar-logo" width="20" height="20" />
        <span>Printable Graph Paper</span>
      </a>
      <div className="navbar-links">
        <a href="/about">About</a>
        <a href="/privacy">Privacy</a>
        <a href="/terms">Terms</a>
        <a href="/contact">Contact</a>
      </div>
      <div className="navbar-right">
        <button
          className="theme-toggle"
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
          {theme === 'dark' ? (
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
              <circle cx="10" cy="10" r="4" />
              <path d="M10 2v2M10 16v2M2 10h2M16 10h2M4.93 4.93l1.41 1.41M13.66 13.66l1.41 1.41M4.93 15.07l1.41-1.41M13.66 6.34l1.41-1.41" />
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
              <path d="M17.39 13.45A8 8 0 016.55 2.6 8 8 0 1017.4 13.44z" />
            </svg>
          )}
        </button>

        {onDownload && onPrint && (
          <div className="navbar-actions" ref={mobileDownloadRef}>
            <div className="navbar-action-btn-wrap">
              <button className="navbar-action-btn" onClick={() => setMobileDownloadOpen(!mobileDownloadOpen)} title="Download">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 2v10" />
                  <path d="M5 8l4 4 4-4" />
                  <path d="M3 15v1h12v-1" />
                </svg>
              </button>
              {mobileDownloadOpen && (
                <div className="navbar-action-dropdown">
                  <button onClick={() => { onDownload('pdf'); setMobileDownloadOpen(false); }}>PDF</button>
                  <button onClick={() => { onDownload('png'); setMobileDownloadOpen(false); }}>PNG</button>
                  <button onClick={() => { onDownload('svg'); setMobileDownloadOpen(false); }}>SVG</button>
                </div>
              )}
            </div>
            <button className="navbar-action-btn" onClick={onPrint} title="Print">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 6V3h8v3" />
                <rect x="3" y="6" width="12" height="7" rx="1.5" />
                <path d="M5 10h8v5H5z" />
              </svg>
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}